<div class="contact-button-container">
  <button class="contact-button paragraph white-color" (click)="navigateToContact()" [innerHTML]="'ContactUs' | translate">
    <span  class="decorative-line d-block"></span>
  </button>
</div>
